import React, { useState } from 'react';
import { useNavigate, useLocation, Location } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Login: React.FC = () => {
  const { signIn, resetPassword } = useAuth();
  const navigate = useNavigate();
  const location = useLocation() as Location & { state?: { from?: Location } };

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [resetting, setResetting] = useState(false);
  const [notice, setNotice] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    setNotice('');
    try {
      const { error: signInError } = await signIn(email, password);
      if (signInError) {
        setError(signInError.message || 'Failed to sign in');
        return;
      }
      const redirectTo = (location.state as any)?.from?.pathname || '/ev';
      navigate(redirectTo, { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Unexpected error');
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async () => {
    setError('');
    setNotice('');
    if (!email) {
      setError('Please enter your email to reset your password.');
      return;
    }
    setResetting(true);
    try {
      const { error: resetError } = await resetPassword(email);
      if (resetError) {
        setError(resetError.message || 'Failed to send reset email');
        return;
      }
      setNotice('If an account exists for this email, a reset link has been sent.');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Unexpected error');
    } finally {
      setResetting(false);
    }
  };

  return (
    <div className="container" style={{ maxWidth: 480, marginTop: 40 }}>
      <h2>Log In</h2>
      {error && (
        <div className="error-message" style={{ marginTop: 12 }}>{error}</div>
      )}
      {notice && (
        <div className="success-message" style={{ marginTop: 12 }}>{notice}</div>
      )}
      <form onSubmit={handleSubmit} style={{ marginTop: 16 }}>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            required
          />
        </div>
        <div style={{ display: 'flex', gap: 12, marginTop: 16 }}>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Signing in…' : 'Log In'}
          </button>
          <button type="button" className="btn btn-secondary" onClick={handleResetPassword} disabled={resetting}>
            {resetting ? 'Sending…' : 'Reset Password'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Login;


